import React from "react";
import { navigate } from "gatsby";
import { useTranslation } from "gatsby-plugin-react-i18next";

import { GATSBY_CONFIGURATION } from "../../config/activeProducts";
import Notifications from "../common/Notifications";
import LazySVGS from "../../images/LazySVGS";
import { Colors } from "../../styles/colors";
import useBreakpoints from "../../hooks/useBreakpoints";
import BubbledExclamation from "../../images/component-svg/BubbledExclamation";
import SeoTenant from "../common/SeoTenant";

const LayoutError = ({ errorTitle, errorMessage, redirectPathErrorMsg, redirectActionErrorMsg, errorBtnTxt, hideErrorBtn, pageContext }) => {
  const { isMobile } = useBreakpoints();
  const { t } = useTranslation();

  return (
    <div className="is-flex is-flex-direction-column is-justify-content-center is-align-items-center">
      <SeoTenant pageContext={pageContext} isNoIndex={true} />

      {GATSBY_CONFIGURATION === "boleron" && <LazySVGS svg="BubbledExclamation" className="default-svg" style={{ marginTop: 40, marginBottom: 25 }} />}

      {GATSBY_CONFIGURATION === "vivacom" && (
        <div className="is-flex is-align-items-center is-justify-content-center mt-6 mb-6" style={{ color: Colors.WHITE }}>
          <LazySVGS svg="ErrorVivacom" className="svg-error-vivacom" />
        </div>
      )}
      <div />

      <span className="error-content-title">{errorTitle || t("key240741", "Опитай пак")}</span>

      <Notifications
        classes="notification-default"
        svgIcon="ExclamationMark"
        message={errorMessage || t("layoutErrorMessageDefault", "Опитай отново!")}
        type="is-primary"
        subType="is-light"
        maxWidth={isMobile ? 340 : 480}
        marginBottom={15}
        marginTop={40}
      />

      {!hideErrorBtn && (
        <button
          type="button"
          className="button is-info is-rounded error-back-btn theme-button"
          onClick={() => {
            if (redirectActionErrorMsg) {
              redirectActionErrorMsg();
            } else if (redirectPathErrorMsg) {
              navigate(redirectPathErrorMsg, { replace: true });
            } else {
              navigate(-1);
            }
          }}
        >
          <span className="is-uppercase" style={{ fontSize: 14 }}>
            {errorBtnTxt || t("Back", "Назад")}
          </span>
        </button>
      )}
    </div>
  );
};

export default LayoutError;
